// React
import React from "react";
import classNames from "classnames";
//  Animated Number
import AnimatedNumber from "react-animated-number";
import FlexItem from "common/ui/containers/flexContainer/FlexItem";
import HoverInfoWrapper from "common/ui/components/tooltips/HoverInfoWrapper";
// Helpers
import * as numberHelper from "common/utils/numberHelper";
//-------------------------------------------------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./DataBar.less";
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class DataBarItem extends React.Component {
    renderNumber(value) {
        if (!value) {
            return (React.createElement("span", null, "-"));
        }
        else {
            return (React.createElement(AnimatedNumber, { component: "span", value: value, stepPrecision: 0, duration: 1000, style: {
                    transition: '0.5s ease-out',
                    transitionProperty: 'background-color, color, opacity'
                }, frameStyle: (perc) => {
                    if (perc <= 25)
                        return { opacity: 0.25 };
                    else if (perc <= 50)
                        return { opacity: 0.50 };
                    else if (perc <= 75)
                        return { opacity: 0.75 };
                    else
                        return { opacity: 1 };
                }, formatValue: value => value && !isNaN(value) ? numberHelper.formatNumber(value) : "-" }));
        }
    }
    sum(total, value) {
        if (value) {
            return total + value;
        }
        else {
            return total;
        }
    }
    render() {
        const { value, unit, description, toolTip } = this.props;
        let valToDisplay = 0;
        if (value) {
            if (typeof value !== "number") {
                valToDisplay = value.reduce(this.sum);
            }
            else {
                valToDisplay = value;
            }
        }
        return (React.createElement(FlexItem, { flexFactor: 1, className: classNames(styles.itemContainer, this.props.bold && styles.bold, this.props.subItem && styles.subItem) },
            React.createElement(HoverInfoWrapper, { tipText: toolTip },
                React.createElement("div", { className: classNames(styles.innerContainer, this.props.subItem && styles.innerContainerSubItem) },
                    React.createElement("div", { className: styles.valueBlock },
                        this.renderNumber(valToDisplay),
                        unit && React.createElement("div", { className: styles.unit }, unit)),
                    React.createElement("div", { className: styles.smallDescription }, description)))));
    }
}
